import { useMediaQuery, useTheme } from '@mui/material';
import { Configuration, SuccessResponse_1OfGetConfigurationResponse } from '../../../../app/services/api/generated';
import { UserContext } from '../../../../components/shared/useUser';
import useNswagClient from '../../../../hooks/api/useNswagClient';
import { useContext, useEffect, useState } from 'react';
import { DrawerNavItem } from '../interfaces/DrawerNavItem';
import { canAccessPageStatus, shouldHideInDemo, isDemoModeEnabled } from '../../../../utils/featureAccess';
import {
  UpdateOutlined, ManageAccountsOutlined, FastfoodOutlined, KitchenOutlined, LocalShippingOutlined,
  ScaleOutlined, MenuBookOutlined, SwapCallsOutlined,
  Checklist,
  CalendarViewWeek,
  Flaky,
  ChecklistRtl,
  Rule,
  LineStyle,
  AssignmentTurnedIn,
  FormatListBulleted,
  FolderOutlined,
  AssessmentOutlined, SchoolOutlined,
  AssignmentTurnedInOutlined, WorkOutlineOutlined, DashboardOutlined, SwapHoriz,
  StorefrontOutlined, StyleOutlined,
  AttachMoneyOutlined,
  NotificationsOutlined,
  Groups, Apartment, Park,
  EventRepeat, DomainAdd, HomeRepairService,
  EditCalendar, Task, Category,
  BusinessCenterOutlined, DescriptionOutlined, RocketLaunchOutlined,
  ArticleOutlined, ContactPageOutlined,
} from '@mui/icons-material';
import {
  ListIcon, Building05, Building02, PackageCheck,
  ShoppingCart01, CoinsSwap02, CoinsHand, BarChart08,
  Truck02, MarkerPin01, ReceiptCheck, FileCheck01, Trash03, Cube,
  Settings01, Truck01, Tag03, Grid01,
  MagicWand01,
} from '../../../../assets';
import { useNavigate } from 'react-router-dom';
import useLogError from '../../../../hooks/useLogError';
import { System } from '../../../../enums/System';
import { allReportPermissions } from '../../../../pages/Reporting/components/shared/ReportTypesData';


const appNavItems: DrawerNavItem[] = [
  /*  {
      canRender: false,
      translationKey: 'home',
      icon: <Home02 />,
      href: '/',
      systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
    }, */
  {
    canRender: false,
    translationKey: 'store',
    icon: <StorefrontOutlined />,
    href: '/store/storefront',
    permissions: ['StorefrontView'],
    systemIds: [System.OrderlyForStores,System.OrderlyForDistributors],
  }, {
    canRender: false,
    translationKey: 'catalogues',
    icon: <ListIcon />,
    href: '/catalogue-list',
    permissions: ['CataloguesView'],
    systemIds: [System.OrderlyForDistributors],
  }, {
    canRender: false,
    translationKey: 'retailers',
    icon: <Building05 />,
    href: '/retailers',
    permissions: ['RetailersView'],
    systemIds: [System.OrderlyForDistributors],
  }, {
    canRender: false,
    translationKey: 'orderList',
    icon: <ShoppingCart01 />,
    href: '/orders',
    permissions: ['OrdersView'],
    systemIds: [System.OrderlyForDistributors],
  }, {
    canRender: false,
    translationKey: 'deliveries',
    icon: <Truck02 />,
    href: '/deliveries',
    permissions: ['DeliveriesView'],
    systemIds: [System.OrderlyForDistributors],
  }/*,{
    canRender: true,
    translationKey: 'claims',
    icon: <FileCheck01 />,
    href: '/claims',
  }*/, {
    canRender: false,
    translationKey: 'finance',
    icon: <CoinsHand />,
    href: '/finance',
    permissions: ['FinanceView'],
    systemIds: [System.OrderlyForDistributors],
  }, {
    canRender: false,
    translationKey: 'reporting',
    icon: <BarChart08 />,
    href: '/reports',
    permissions: [...allReportPermissions],
    systemIds: [System.OrderlyForDistributors],
  },
  {
    canRender: false,
    translationKey: 'orderStock',
    icon: <ShoppingCart01 />,
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'browseProducts',
        icon: <ListIcon />,
        permissions: ['OrderableItemsRead'],
        href: '/store/orderable-items',
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'historicalOrders',
        icon: <LocalShippingOutlined />,
        href: '/store/orders-history',
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'orderViaForm',
        icon: <UpdateOutlined />,
        href: '/store/order-planning',
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'bulkOrder',
    icon: <PackageCheck />,
    permissions: ['BulkOrdersRead'],
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'bulkOrderManagement',
        icon: <ListIcon />,
        href: '/bulk-order-management',
        permissions: ['BulkOrdersRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'demandModifiers',
        icon: <UpdateOutlined />,
        href: '/demand-modifiers',
        permissions: ['BulkOrdersRead'],
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'receiveStock',
    icon: <LocalShippingOutlined />,
    permissions: ['PurchaseOrderRead'],
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'purchaseOrder',
        icon: <ReceiptCheck />,
        href: '/store/goods-receipts',
        permissions: ['PurchaseOrderRead'],
        systemIds: [System.OrderlyForStores],
      }, {
        canRender: false,
        translationKey: 'invoices',
        icon: <FileCheck01 />,
        href: '/invoices',
        permissions: ['InvoiceReconciliationRead', 'InvoiceReconciliationWrite', 'InvoiceReconciliationAdmin'],
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'transferStock',
    icon: <SwapCallsOutlined />,
    permissions: ['TransferRead'],
    href: '/store/stock-transfers',
    systemIds: [System.OrderlyForStores],
  },
  {
    canRender: false,
    translationKey: 'wasteStock',
    icon: <Trash03 />,
    href: '/store/waste-logs',
    permissions: ['DailyWasteCheckSheetRead'],
    systemIds: [System.OrderlyForStores],
  },
  {
    canRender: false,
    translationKey: 'count',
    icon: <Cube />,
    permissions: ['StockRead', 'StockCountAdmin', 'StockCountRead', 'StockLocationRead'],
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'stockCount',
        icon: <PackageCheck />,
        href: '/store/stock-count',
        permissions: ['StockCountAdmin', 'StockCountRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'stockOnHand',
        icon: <CoinsHand />,
        permissions: ['StockRead'],
        href: '/store/stock',
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'countZones',
        icon: <MarkerPin01 />,
        href: '/store/stock-count-zones',
        permissions: ['StockLocationRead'],
        storePermission: 'LocationsEnabled',
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'transactions',
    icon: <CoinsSwap02 />,
    permissions: ['TransactionAdmin', 'TransactionRead', 'POSMapping'],
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'transactions',
        icon: <CoinsSwap02 />,
        href: '/transactions',
        permissions: ['TransactionAdmin', 'TransactionRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'itemMapping',
        icon: <SwapHoriz />,
        href: '/manage-item-mapping',
        permissions: ['POSMapping'],
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'cashManagement',
    icon: <CoinsHand />,
    permissions: ['CashManagementView', 'CashManagementCreate', 'CashManagementEdit', 'CashManagementDelete', 'CashManagementReconcile', 'CashReconciliationRead'],
    systemIds: [System.OrderlyForStores],
    status: 'demo',
    children: [
      {
        canRender: false,
        translationKey: 'cashOverview',
        icon: <CoinsHand />,
        permissions: ['CashManagementView', 'CashManagementCreate', 'CashManagementEdit', 'CashManagementDelete', 'CashManagementReconcile'],
        href: '/cash-management',
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'cashReconciliation',
        icon: <CoinsSwap02 />,
        permissions: ['CashReconciliationRead'],
        href: '/cash-reconciliation',
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'products',
    icon: <FastfoodOutlined />,
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'viewItems',
        icon: <FastfoodOutlined />,
        href: '/store/products?allItems=true',
        permissions: ['ItemRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'viewRecipes',
        icon: <KitchenOutlined />,
        href: '/store/recipes',
        permissions: ['RecipeRead'],
        systemIds: [System.OrderlyForStores],
        hideInDemo: true,
      },
      {
        canRender: false,
        translationKey: 'dataQuality',
        icon: <ScaleOutlined />,
        href: '/store/data-quality',
        permissions: ['RecipeV2RationaliseRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'uomConversions',
        icon: <ScaleOutlined />,
        href: '/uom-conversions',
        permissions: ['ConversionRead'],
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'procurement',
    icon: <LocalShippingOutlined />,
    systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
    status: 'preview',
    children: [
      {
        canRender: false,
        translationKey: 'procurementOverview',
        icon: <DashboardOutlined />,
        href: '/procurement/overview',
        permissions: ['ProductView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'suppliers',
        icon: <Truck01 />,
        href: '/procurement/suppliers',
        permissions: ['SupplierView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'supplierOnboarding',
        icon: <ContactPageOutlined />,
        href: '/procurement/suppliers/onboarding',
        permissions: ['SupplierCreate'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'supplierExceptions',
        icon: <Flaky />,
        href: '/procurement/suppliers/exceptions',
        permissions: ['SupplierView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'catalogues',
        icon: <ListIcon />,
        href: '/procurement/catalogues',
        permissions: ['CatalogueView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'procurementCategories',
        icon: <Tag03 />,
        href: '/procurement/categories',
        permissions: ['CategoryView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'orderChannels',
        icon: <StyleOutlined />,
        href: '/procurement/order-channels',
        permissions: ['OrderTypeView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'products',
        icon: <FastfoodOutlined />,
        href: '/procurement/products',
        permissions: ['ProductView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'catalogueGovernance',
        icon: <Rule />,
        href: '/procurement/catalogue-governance',
        permissions: ['ProductView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'newsAndCommunications',
    icon: <ArticleOutlined />,
    href: '/news',
    permissions: ['NewsConsume'],
    status: 'demo',
    systemIds: [System.OrderlyForStores],
  },
  {
    canRender: false,
    translationKey: 'tasks',
    icon: <Checklist />,
    permissions: ['OperationalDaysViewDashboard', 'AdvancedTasksView'],
    systemIds: [System.OrderlyForStores],
    status: 'demo',
    children: [
      {
        canRender: false,
        translationKey: 'operationalDay',
        icon: <LineStyle />,
        href: '/operational-day',
        permissions: ['OperationalDaysViewDashboard'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'taskDashboard',
        icon: <AssignmentTurnedIn />,
        href: '/task-reporting',
        permissions: ['AdvancedTasksView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'tasks',
        icon: <FormatListBulleted />,
        href: '/tasks',
        permissions: ['AdvancedTasksView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'financePerformance',
    icon: <AttachMoneyOutlined />,
    href: '/finance-performance',
    permissions: ['FinanceDashboardView', 'FinanceProfitAndLossView', 'CommercialPerformanceView'],
    systemIds: [System.OrderlyForStores],
    status: 'demo',
  },
  // Compliance & Controls Module
  {
    canRender: false,
    translationKey: 'controlsDashboard',
    icon: <DashboardOutlined />,
    href: '/compliance/controls-dashboard',
    permissions: ['ViewComplianceDashboard'],
    systemIds: [System.OrderlyForCompliance],
    status: 'demo',
  },
  {
    canRender: false,
    translationKey: 'audits',
    icon: <AssessmentOutlined />,
    href: '/compliance/audits/history',
    permissions: ['AuditsView'],
    systemIds: [System.OrderlyForCompliance],
  },
  {
    canRender: false,
    translationKey: 'actionItems',
    icon: <AssignmentTurnedInOutlined />,
    href: '/compliance/audits/action-items',
    permissions: ['ActionItemsView'],
    systemIds: [System.OrderlyForCompliance],
  },
  {
    canRender: false,
    translationKey: 'issuesExceptions',
    icon: <Flaky />,
    href: '/compliance/issues',
    permissions: ['ActionItemsView'],
    systemIds: [System.OrderlyForCompliance],
    status: 'demo',
  },
  {
    canRender: false,
    translationKey: 'controlAreas',
    icon: <Category />,
    href: '/compliance/control-areas',
    permissions: ['ViewComplianceDashboard'],
    systemIds: [System.OrderlyForCompliance],
    status: 'demo',
  },
  {
    canRender: false,
    translationKey: 'setupAndTemplates',
    icon: <FileCheck01 />,
    permissions: ['AuditsView'],
    systemIds: [System.OrderlyForCompliance],
    children: [
      {
        canRender: false,
        translationKey: 'auditTypes',
        icon: <ListIcon />,
        href: '/compliance/audits/types',
        permissions: ['AuditTypesView'],
        systemIds: [System.OrderlyForCompliance],
      },
      {
        canRender: false,
        translationKey: 'auditTemplates',
        icon: <FileCheck01 />,
        href: '/compliance/audits/templates',
        permissions: ['AuditTemplatesView'],
        systemIds: [System.OrderlyForCompliance],
      },
      {
        canRender: false,
        translationKey: 'auditSchedules',
        icon: <BarChart08 />,
        href: '/compliance/audits/schedules',
        permissions: ['ScheduledAuditsCreate'],
        systemIds: [System.OrderlyForCompliance],
      },
      {
        canRender: false,
        translationKey: 'controlTemplates',
        icon: <FileCheck01 />,
        href: '/compliance/setup/control-templates',
        permissions: ['AuditTemplatesView'],
        systemIds: [System.OrderlyForCompliance],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'training',
    icon: <SchoolOutlined />,
    permissions: ['ViewTraining'],
    systemIds: [System.OrderlyForCompliance],
    children: [
      {
        canRender: false,
        translationKey: 'trainingCategories',
        icon: <ListIcon />,
        href: '/compliance/training/categories',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForCompliance],
      },
      {
        canRender: false,
        translationKey: 'trainingModules',
        icon: <MenuBookOutlined />,
        href: '/compliance/training/modules',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForCompliance],
      },
      {
        canRender: false,
        translationKey: 'trainingCoursesPacks',
        icon: <FolderOutlined />,
        href: '/compliance/training/courses-packs',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForCompliance],
      },
      {
        canRender: false,
        translationKey: 'myTraining',
        icon: <SchoolOutlined />,
        href: '/compliance/training/my-training',
        permissions: ['TrainingAccess'],
        systemIds: [System.OrderlyForCompliance],
      },
      {
        canRender: false,
        translationKey: 'trainingAssignments',
        icon: <AssignmentTurnedInOutlined />,
        href: '/compliance/training/assignments',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForCompliance],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'complianceReports',
    icon: <BarChart08 />,
    href: '/compliance/reports',
    permissions: ['ViewComplianceReports', 'TrainingSummaryReportRead', 'TrainingCompletionReportRead'],
    systemIds: [System.OrderlyForCompliance],
  },
  //compliance for non-compliance users
  {
    canRender: false,
    translationKey: 'compliance',
    icon: <FileCheck01 />,
    permissions: ['AuditsView'],
    systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
    children: [
      {
        canRender: false,
        translationKey: 'controlsDashboard',
        icon: <DashboardOutlined />,
        href: '/compliance/controls-dashboard',
        permissions: ['ViewComplianceDashboard'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'audits',
        icon: <AssessmentOutlined />,
        href: '/compliance/audits/history',
        permissions: ['AuditsView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'actionItems',
        icon: <AssignmentTurnedInOutlined />,
        href: '/compliance/audits/action-items',
        permissions: ['ActionItemsView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'issuesExceptions',
        icon: <Flaky />,
        href: '/compliance/issues',
        permissions: ['ActionItemsView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'controlAreas',
        icon: <Category />,
        href: '/compliance/control-areas',
        permissions: ['ViewComplianceDashboard'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'setupAndTemplates',
        icon: <FileCheck01 />,
        permissions: ['AuditsView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        children: [
          {
            canRender: false,
            translationKey: 'auditTypes',
            icon: <ListIcon />,
            href: '/compliance/audits/types',
            permissions: ['AuditTypesView'],
            systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
          },
          {
            canRender: false,
            translationKey: 'auditTemplates',
            icon: <FileCheck01 />,
            href: '/compliance/audits/templates',
            permissions: ['AuditTemplatesView'],
            systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
          },
          {
            canRender: false,
            translationKey: 'auditSchedules',
            icon: <BarChart08 />,
            href: '/compliance/audits/schedules',
            permissions: ['ScheduledAuditsCreate'],
            systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
          },
          {
            canRender: false,
            translationKey: 'controlTemplates',
            icon: <FileCheck01 />,
            href: '/compliance/setup/control-templates',
            permissions: ['AuditTemplatesView'],
            systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
            status: 'demo',
          },
        ],
      },
      {
        canRender: false,
        translationKey: 'trainingCategories',
        icon: <ListIcon />,
        href: '/compliance/training/categories',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'trainingModules',
        icon: <MenuBookOutlined />,
        href: '/compliance/training/modules',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'myTraining',
        icon: <SchoolOutlined />,
        href: '/compliance/training/my-training',
        permissions: ['TrainingAccess'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'trainingAssignments',
        icon: <AssignmentTurnedInOutlined />,
        href: '/compliance/training/assignments',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
      {
        canRender: false,
        translationKey: 'complianceReports',
        icon: <BarChart08 />,
        href: '/compliance/reports',
        permissions: ['ViewComplianceReports', 'TrainingSummaryReportRead', 'TrainingCompletionReportRead'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'reporting',
    icon: <BarChart08 />,
    href: '/reports',
    permissions: [...allReportPermissions],
    systemIds: [System.OrderlyForStores, System.OrderlyForCompliance],
  }];

/**
 * Demo Mode only - an ALTERNATE full main-nav tree organised by workspace (Orderly Hub,
 * Ordering, Inventory, Site Operations, Finance) rather than the flat/mixed grouping in
 * `appNavItems` above. Selected instead of (not alongside) `appNavItems` when Demo Mode is
 * enabled - see the `isDemoModeEnabled()` check where `appNavItemsToUse` is built below, so
 * production nav for non-demo users is completely unaffected.
 *
 * Every href here points at an EXISTING route; nothing here is a new page. `credits` has no
 * dedicated list screen yet, so it links to the Goods Receipts screen where credit requests
 * are actually raised/tracked per delivery - a real standalone Credits screen would be a
 * separate future ask, not built here.
 */
const demoWorkspaceNavItems: DrawerNavItem[] = [
  {
    // Demo Mode preview only - customer-first Customer Hub. Covers the "win or renew the client
    // contract" journey milestone: turning a signed contract into a controlled operating model
    // before any ordering or range planning activity begins. The old flat menu (Customer
    // Overview/Contracts & Terms/Mobilisation Plans/Reporting Requirements/Contacts/Commercial
    // Model/Customer Sites) is now a single customer workspace reached via these 4 entry points -
    // see `pages/CustomerManagement/CustomerWorkspace` for the per-customer tabs.
    canRender: false,
    translationKey: 'workspaceCustomerManagement',
    icon: <BusinessCenterOutlined />,
    systemIds: [System.OrderlyForStores],
    status: 'demo',
    children: [
      {
        canRender: false,
        translationKey: 'customerHub',
        icon: <DashboardOutlined />,
        href: '/customer-management/dashboard',
        permissions: ['CustomerHubView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'allCustomers',
        icon: <BusinessCenterOutlined />,
        href: '/customer-management/customers',
        permissions: ['CustomerHubView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'onboardingPipeline',
        icon: <RocketLaunchOutlined />,
        href: '/customer-management/onboarding-pipeline',
        permissions: ['CustomerHubView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'contractRenewals',
        icon: <DescriptionOutlined />,
        href: '/customer-management/contract-renewals',
        permissions: ['CustomerHubView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceEstateManagement',
    icon: <Apartment />,
    systemIds: [System.OrderlyForStores],
    status: 'demo',
    children: [
      {
        canRender: false,
        translationKey: 'estateOverview',
        icon: <Apartment />,
        href: '/estate-management/overview',
        permissions: ['EstateManagementView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'siteDevelopment',
        icon: <DomainAdd />,
        href: '/estate-management/site-development',
        permissions: ['StoreDevelopmentView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'equipment',
        icon: <MenuBookOutlined />,
        href: '/estate-management/equipment',
        permissions: ['EquipmentCatalogueView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'serviceRequests',
        icon: <AssignmentTurnedInOutlined />,
        href: '/estate-management/service-requests',
        permissions: ['ServiceRequestsView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'maintenanceCompliance',
        icon: <EventRepeat />,
        href: '/estate-management/maintenance-compliance',
        permissions: ['MaintenanceComplianceView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceRangePlanning',
    icon: <KitchenOutlined />,
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'rangeOverview',
        icon: <AssessmentOutlined />,
        href: '/range-planning/range-overview',
        permissions: ['RangeOverviewRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'rangeDevelopment',
        icon: <AssignmentTurnedInOutlined />,
        href: '/range-planning/range-development',
        permissions: ['RangeDevelopmentRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'ranges',
        icon: <AssessmentOutlined />,
        href: '/range/ranges',
        permissions: ['RangeRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'menus',
        icon: <MenuBookOutlined />,
        href: '/range/menus',
        permissions: ['MenuRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'viewRecipesV2',
        icon: <KitchenOutlined />,
        href: '/range/recipes',
        permissions: ['RecipeV2Read'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'viewRecipeBank',
        icon: <FolderOutlined />,
        href: '/range/recipe-bank',
        permissions: ['RecipeV2Read'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'viewRecipeComplianceMatrix',
        icon: <Rule />,
        href: '/range/recipe-compliance-matrix',
        permissions: ['RecipeV2Read'],
        status: 'demo',
        systemIds: [System.OrderlyForStores],
        hideInDemo: true,
      },
      {
        canRender: false,
        translationKey: 'viewRecipeComplianceMatrix',
        icon: <Rule />,
        href: '/range/recipe-compliance-matrix',
        permissions: ['RecipeV2Read'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'attributesAllergens',
        icon: <Category />,
        href: '/range-planning/attributes-allergens',
        permissions: ['AttributesAllergensRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'itemRationalisation',
        icon: <Trash03 />,
        href: '/range-planning/item-rationalisation',
        permissions: ['ItemRationalisationRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'referenceData',
        icon: <FolderOutlined />,
        href: '/range-planning/reference-data',
        permissions: ['ReferenceDataRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        // Links into the OFD (Orderly for Distributors) catalogue -> products/items ->
        // product details hierarchy so the "missing required documents" indicator on the
        // products/items table (see CatalogueProductsTable.tsx) can be showcased from the
        // Range Planning demo nav. Real OFD permission (CataloguesView etc.), bypassed for
        // any demo persona via the route's status="demo" AuthGuard (see App.tsx).
        canRender: false,
        translationKey: 'catalogues',
        icon: <ListIcon />,
        href: '/catalogue-list',
        permissions: ['CataloguesView'],
        systemIds: [System.OrderlyForStores, System.OrderlyForDistributors],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'procurement',
    icon: <LocalShippingOutlined />,
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'procurementOverview',
        icon: <DashboardOutlined />,
        href: '/procurement/overview',
        permissions: ['ProductView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'procurementReadiness',
        icon: <AssignmentTurnedIn />,
        href: '/procurement/readiness',
        permissions: ['ProductView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'catalogues',
        icon: <ListIcon />,
        href: '/procurement/catalogues',
        permissions: ['CatalogueView'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'products',
        icon: <FastfoodOutlined />,
        href: '/procurement/products',
        permissions: ['ProductView'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'ordering',
        icon: <StyleOutlined />,
        href: '/procurement/ordering',
        permissions: ['OrderTypeView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'procurementExceptions',
        icon: <Flaky />,
        href: '/procurement/exceptions',
        permissions: ['SupplierView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'governance',
        icon: <Rule />,
        href: '/procurement/governance',
        permissions: ['ProductView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'referenceData',
        icon: <Tag03 />,
        href: '/procurement/reference-data',
        permissions: ['CategoryView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceSiteOperations',
    icon: <LineStyle />,
    permissions: ['OperationalDaysViewDashboard', 'AdvancedTasksView'],
    systemIds: [System.OrderlyForStores],
    status: 'demo',
    children: [
      {
        canRender: false,
        translationKey: 'operationalDay',
        icon: <LineStyle />,
        href: '/operational-day',
        permissions: ['OperationalDaysViewDashboard'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'taskDashboard',
        icon: <AssignmentTurnedIn />,
        href: '/task-reporting',
        permissions: ['AdvancedTasksView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'tasks',
        icon: <FormatListBulleted />,
        href: '/tasks',
        permissions: ['AdvancedTasksView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'scheduledTasks',
        icon: <EventRepeat />,
        href: '/task-schedules',
        permissions: ['TaskSchedulesView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'operationalDaySetup',
        icon: <EditCalendar />,
        href: '/operational-days',
        permissions: ['OperationalDaysView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'taskTemplates',
        icon: <Task />,
        href: '/task-templates',
        permissions: ['TaskTemplatesViewUnrestricted'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'manageTaskCategories',
        icon: <Category />,
        href: '/manage-task-categories',
        permissions: ['TaskCategoriesView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'mySite',
        icon: <Apartment />,
        href: '/site-operations/my-site',
        permissions: ['MySiteView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'siteOperationsEquipment',
        icon: <HomeRepairService />,
        href: '/site-operations/equipment',
        permissions: ['SiteOperationsEquipmentView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'siteOperationsServiceRequests',
        icon: <AssignmentTurnedInOutlined />,
        href: '/site-operations/service-requests',
        permissions: ['SiteOperationsServiceRequestsView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceWorkforce',
    icon: <Groups />,
    systemIds: [System.OrderlyForStores],
    status: 'demo',
    children: [
      {
        canRender: false,
        translationKey: 'trainingDashboard',
        icon: <SchoolOutlined />,
        href: '/compliance/dashboard?view=training',
        permissions: ['ViewTrainingDashboard'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'trainingModules',
        icon: <MenuBookOutlined />,
        href: '/compliance/training/modules',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'trainingCoursesPacks',
        icon: <FolderOutlined />,
        href: '/compliance/training/courses-packs',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'trainingAssignments',
        icon: <AssignmentTurnedInOutlined />,
        href: '/compliance/training/assignments',
        permissions: ['TrainingAdmin', 'TrainingAssignmentViewer', 'TrainingAssignmentManager'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'labourManagement',
        icon: <AssessmentOutlined />,
        href: '/labour-management',
        permissions: ['LabourManagementView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'trainingCategories',
        icon: <ListIcon />,
        href: '/compliance/training/categories',
        permissions: ['TrainingAdmin', 'TrainingContentManager', 'TrainingContentViewer'],
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceOrdering',
    icon: <ShoppingCart01 />,
    systemIds: [System.OrderlyForStores],
    children: [
      {
        // Demo Mode label only - real production Storefront nav entry (translationKey
        // 'store', appNavItems above) is untouched; this demo-tree copy uses a dedicated
        // key so only the demo nav shows "Restaurant" wording.
        canRender: false,
        translationKey: 'restaurant',
        icon: <StorefrontOutlined />,
        href: '/store/storefront',
        permissions: ['StorefrontView'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'quickOrder',
        icon: <MagicWand01 />,
        href: '/store/quick-order',
        permissions: ['User'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'browseProducts',
        icon: <ListIcon />,
        href: '/store/orderable-items',
        permissions: ['OrderableItemsRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'orderViaForm',
        icon: <UpdateOutlined />,
        href: '/store/order-planning',
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'historicalOrders',
        icon: <LocalShippingOutlined />,
        href: '/store/orders-history',
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'bulkOrderManagement',
        icon: <PackageCheck />,
        href: '/bulk-order-management',
        permissions: ['BulkOrdersRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'demandModifiers',
        icon: <UpdateOutlined />,
        href: '/demand-modifiers',
        permissions: ['BulkOrdersRead'],
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceInventory',
    icon: <Cube />,
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'stockLevels',
        icon: <CoinsHand />,
        href: '/store/stock',
        permissions: ['StockRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'stockCount',
        icon: <PackageCheck />,
        href: '/store/stock-count',
        permissions: ['StockCountAdmin', 'StockCountRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'wasteStock',
        icon: <Trash03 />,
        href: '/store/waste-logs',
        permissions: ['DailyWasteCheckSheetRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'transferStock',
        icon: <SwapCallsOutlined />,
        href: '/store/stock-transfers',
        permissions: ['TransferRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'deliveries',
        icon: <Truck02 />,
        href: '/store/goods-receipts',
        permissions: ['PurchaseOrderRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'countStockSchedule',
        icon: <PackageCheck />,
        href: '/stock-counts',
        permissions: ['StockCountAdmin', 'StockCountScheduleRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'stockCountUoms',
        icon: <ScaleOutlined />,
        href: '/stock-count-uoms',
        permissions: ['StockCountAdmin', 'StockCountUomsRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'countZones',
        icon: <MarkerPin01 />,
        href: '/count-zones',
        permissions: ['StockCountAdmin', 'StockLocationRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'transactions',
        icon: <CoinsSwap02 />,
        href: '/transactions',
        permissions: ['TransactionAdmin', 'TransactionRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'manageCategory',
        icon: <Grid01 />,
        href: '/manage-categories',
        permissions: ['CategoryAdmin'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'itemMapping',
        icon: <SwapHoriz />,
        href: '/manage-item-mapping',
        permissions: ['POSMapping'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'compliance',
    icon: <FileCheck01 />,
    permissions: ['AuditsView'],
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'auditsDashboard',
        icon: <DashboardOutlined />,
        href: '/compliance/dashboard?view=audits',
        permissions: ['ViewAuditDashboard'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'auditTemplates',
        icon: <FileCheck01 />,
        href: '/compliance/audits/templates',
        permissions: ['AuditTemplatesView'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'auditSchedules',
        icon: <BarChart08 />,
        href: '/compliance/audits/schedules',
        permissions: ['ScheduledAuditsCreate'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'actionItems',
        icon: <AssignmentTurnedInOutlined />,
        href: '/compliance/audits/action-items',
        permissions: ['ActionItemsView'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'auditTypes',
        icon: <ListIcon />,
        href: '/compliance/audits/types',
        permissions: ['AuditTypesView'],
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceSustainability',
    icon: <Park />,
    systemIds: [System.OrderlyForStores],
    status: 'demo',
    children: [
      {
        canRender: false,
        translationKey: 'sustainabilityOverview',
        icon: <Park />,
        href: '/sustainability',
        permissions: ['SustainabilityView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'wasteManagementDashboard',
        icon: <Park />,
        href: '/waste-management-dashboard',
        permissions: ['WasteManagementDashboardView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'supplierEsg',
        icon: <Truck01 />,
        href: '/procurement/suppliers/esg-dashboard',
        permissions: ['SupplierEsgDashboardView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceFinance',
    icon: <AttachMoneyOutlined />,
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'financePerformance',
        icon: <AttachMoneyOutlined />,
        href: '/finance-performance',
        permissions: ['FinanceDashboardView', 'FinanceProfitAndLossView', 'CommercialPerformanceView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'deliveryReconciliation',
        icon: <Truck02 />,
        href: '/delivery-reconciliation',
        permissions: ['DeliveryReconciliationView'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'invoices',
        icon: <FileCheck01 />,
        href: '/invoices',
        permissions: ['InvoiceReconciliationRead', 'InvoiceReconciliationWrite', 'InvoiceReconciliationAdmin'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'credits',
        icon: <FileCheck01 />,
        href: '/store/goods-receipts',
        permissions: ['PurchaseOrderRead'],
        systemIds: [System.OrderlyForStores],
      },
      {
        // Links out to the real OFD (Orderly for Distributors) Finance page - kept demo-visible
        // here under System.OrderlyForStores (rather than its native OrderlyForDistributors
        // systemId) so it can be showcased directly from the Stores demo workspace nav.
        canRender: false,
        translationKey: 'finance',
        icon: <CoinsHand />,
        href: '/finance',
        permissions: ['FinanceView'],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'cashManagement',
        icon: <CoinsHand />,
        href: '/cash-management',
        permissions: ['CashManagementView', 'CashManagementCreate', 'CashManagementEdit', 'CashManagementDelete', 'CashManagementReconcile'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
    ],
  },
  {
    canRender: false,
    translationKey: 'workspaceDataInsights',
    icon: <BarChart08 />,
    systemIds: [System.OrderlyForStores],
    children: [
      {
        canRender: false,
        translationKey: 'dataQuality',
        icon: <ScaleOutlined />,
        href: '/store/data-quality',
        permissions: ['RecipeV2RationaliseRead'],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'reportingV2',
        icon: <BarChart08 />,
        href: '/reports/v2',
        permissions: [...allReportPermissions],
        systemIds: [System.OrderlyForStores],
        status: 'demo',
      },
      {
        canRender: false,
        translationKey: 'reporting',
        icon: <BarChart08 />,
        href: '/reports',
        permissions: [...allReportPermissions],
        systemIds: [System.OrderlyForStores],
      },
      {
        canRender: false,
        translationKey: 'complianceReports',
        icon: <BarChart08 />,
        href: '/compliance/reports',
        permissions: ['ViewComplianceReports', 'TrainingSummaryReportRead', 'TrainingCompletionReportRead'],
        systemIds: [System.OrderlyForStores],
      },
    ],
  },
];


const systemNavItems: DrawerNavItem[] = [{
  canRender: true,
  translationKey: 'userSettings',
  icon: <ManageAccountsOutlined />,
  systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
  children: [
    {
      canRender: true,
      translationKey: 'userSettings',
      icon: <ManageAccountsOutlined />,
      href: '/user-settings',
      systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
    },
    {
      canRender: true,
      translationKey: 'notificationPreferences',
      icon: <ManageAccountsOutlined />,
      href: '/user-settings/notifications',
      systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
    },
  ],
}, {
  // Demo Mode preview only - consolidates Tasks (which still also appears in its existing
  // location elsewhere in the main nav), plus Compliance Action Items, My Audits and My
  // Training (moved here from the main Compliance workspace group) into a single
  // bottom-of-drawer group, to preview a future "Notifications" concept without moving or
  // hiding anything for current production users. Each child keeps its own real permissions,
  // so it only shows for users who already have access via the existing nav entry.
  canRender: false,
  translationKey: 'notifications',
  icon: <NotificationsOutlined />,
  permissions: ['AdvancedTasksView', 'ActionItemsView', 'AuditsView', 'TrainingAccess'],
  systemIds: [System.OrderlyForStores, System.OrderlyForCompliance],
  status: 'demo',
  children: [
    {
      canRender: false,
      translationKey: 'tasks',
      icon: <FormatListBulleted />,
      href: '/tasks',
      permissions: ['AdvancedTasksView'],
      systemIds: [System.OrderlyForStores],
    },
    {
      canRender: false,
      translationKey: 'actionItems',
      icon: <AssignmentTurnedInOutlined />,
      href: '/compliance/audits/action-items',
      permissions: ['ActionItemsView'],
      systemIds: [System.OrderlyForCompliance],
    },
    {
      canRender: false,
      translationKey: 'myAudits',
      icon: <AssessmentOutlined />,
      href: '/compliance/audits/history',
      permissions: ['AuditsView'],
      systemIds: [System.OrderlyForCompliance],
    },
    {
      canRender: false,
      translationKey: 'myTraining',
      icon: <SchoolOutlined />,
      href: '/compliance/training/my-training',
      permissions: ['TrainingAccess'],
      systemIds: [System.OrderlyForCompliance],
    },
  ],
}, {
  canRender: true,
  translationKey: 'documents',
  icon: <FolderOutlined />,
  href: '/documents',
  permissions: ['DocumentsView'],
  status: 'demo',
  systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
}, {
  canRender: true,
  translationKey: 'settings',
  icon: <Settings01 />,
  href: '/settings',
  systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
},
];

/**
 * Demo Mode only - alternate variant of `systemNavItems` (the bottom-of-drawer footer
 * section). Renames the 'notifications' preview group's label to "Tasks" and adds
 * standalone My Training / My Audits / User Settings entries. `systemNavItems` itself is
 * left completely untouched so production (non-demo) users see zero change - see the
 * `isDemoModeEnabled()` swap where `systemNavItemsToUse` is built below.
 */
const demoSystemNavItems: DrawerNavItem[] = [{
  canRender: false,
  translationKey: 'tasks',
  icon: <NotificationsOutlined />,
  permissions: ['AdvancedTasksView', 'ActionItemsView', 'AuditsView', 'TrainingAccess'],
  systemIds: [System.OrderlyForStores, System.OrderlyForCompliance],
  status: 'demo',
  children: [
    {
      canRender: false,
      translationKey: 'tasks',
      icon: <FormatListBulleted />,
      href: '/tasks',
      permissions: ['AdvancedTasksView'],
      systemIds: [System.OrderlyForStores],
    },
    {
      canRender: false,
      translationKey: 'actionItems',
      icon: <AssignmentTurnedInOutlined />,
      href: '/compliance/audits/action-items',
      permissions: ['ActionItemsView'],
      systemIds: [System.OrderlyForCompliance],
    },
    {
      canRender: false,
      translationKey: 'myAudits',
      icon: <AssessmentOutlined />,
      href: '/compliance/audits/history',
      permissions: ['AuditsView'],
      systemIds: [System.OrderlyForCompliance],
    },
    {
      canRender: false,
      translationKey: 'myTraining',
      icon: <SchoolOutlined />,
      href: '/compliance/training/my-training',
      permissions: ['TrainingAccess'],
      systemIds: [System.OrderlyForCompliance],
    },
  ],
}, {
  // Demo Mode preview only - standalone top-level entries so My Training/My Audits sit
  // directly in the user-settings/tasks/documents/settings footer menu, above Documents.
  canRender: false,
  translationKey: 'myTraining',
  icon: <SchoolOutlined />,
  href: '/compliance/training/my-training',
  permissions: ['TrainingAccess'],
  systemIds: [System.OrderlyForCompliance],
  status: 'demo',
}, {
  canRender: false,
  translationKey: 'myAudits',
  icon: <AssessmentOutlined />,
  href: '/compliance/audits/history',
  permissions: ['AuditsView'],
  systemIds: [System.OrderlyForCompliance],
  status: 'demo',
}, {
  canRender: false,
  translationKey: 'documents',
  icon: <FolderOutlined />,
  href: '/documents',
  permissions: ['DocumentsView'],
  status: 'demo',
  systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
}, {
  canRender: true,
  translationKey: 'userSettings',
  icon: <ManageAccountsOutlined />,
  systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
  children: [
    {
      canRender: true,
      translationKey: 'userSettings',
      icon: <ManageAccountsOutlined />,
      href: '/user-settings',
      systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
    },
    {
      canRender: true,
      translationKey: 'notificationPreferences',
      icon: <ManageAccountsOutlined />,
      href: '/user-settings/notifications',
      systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
    },
  ],
}, {
  canRender: true,
  translationKey: 'settings',
  icon: <Settings01 />,
  href: '/settings',
  systemIds: [System.OrderlyForStores, System.OrderlyForDistributors, System.OrderlyForCompliance],
},
];

export const useDrawer = () => {
  const { getConfigurations } = useNswagClient();
  const theme = useTheme();
  const { selectedStore, hasPermissionTo, user, selectedSystem, systems, demoPersona } = useContext(UserContext);
  const [storeConfig, setStoreConfig] = useState<Configuration[]>([]);
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [selectedNavItem, setSelectedNavItem] = useState<DrawerNavItem>();
  const slidingSubMenuWidth = 320;
  const { logError } = useLogError();
  const [appNavItemsToUse, setAppNavItemsToUse] = useState<DrawerNavItem[]>([]);
  const [systemNavItemsToUse, setSystemNavItemsToUse] = useState<DrawerNavItem[]>([]);

  useEffect(() => {
    if (selectedSystem) {

      const updatedNavItems = (isDemoModeEnabled() ? demoWorkspaceNavItems : appNavItems).map((item) => {
        checkPermissions(item, storeConfig);
        return item;
      });

      setAppNavItemsToUse(updatedNavItems);

      const updatedSystemNavItems = (isDemoModeEnabled() ? demoSystemNavItems : systemNavItems).map((item) => {
        checkPermissions(item, storeConfig);
        return item;
      });

      setSystemNavItemsToUse(updatedSystemNavItems);

    } else {
      setAppNavItemsToUse([]);
      setSystemNavItemsToUse([]);
    }
    // demoPersona is a dependency (not just storeConfig/selectedSystem) because checkPermissions
    // calls hasPermissionTo, which narrows by the currently selected demo persona - without this,
    // switching the Demo Role picker wouldn't recompute which nav items are visible.
  }, [selectedSystem, storeConfig, demoPersona]);

  const handleNavItemClick = (item: DrawerNavItem) => {
    if (item.href || ((item.children?.length ?? 0) > 0)) {
      const renderableChildren = item.children?.filter(c => c.canRender !== false);

      // If only one child is accessible, navigate directly to it
      if (renderableChildren?.length === 1 && renderableChildren[0].href) {
        setSelectedNavItem(undefined);
        navigate(renderableChildren[0].href);
        return;
      }

      setSelectedNavItem((prev) => {
        if (!item?.children) return undefined;
        return prev?.translationKey === item.translationKey ? undefined : item;
      });

      if (!item.children) {
        navigate(item.href ?? '/');
      }
    }
  };

  useEffect(() => {
    if (selectedStore) {
      getConfigurations(selectedStore.franchiseName ?? '', selectedStore.storeNumber ?? '')
        .then((result: SuccessResponse_1OfGetConfigurationResponse) => {
          setStoreConfig(result.data?.configurations ?? []);
        })
        .catch((error) => logError(error));
    }
  }, [selectedStore, user]);

  const hasStorePermission = (per: string | undefined, config: Configuration[]): boolean => {
    if (per === undefined) return true;

    return config.some(x => x.name === per && x.value === 'true');
  };

  const checkPermissions = (item: DrawerNavItem, configurations: Configuration[]): boolean => {
    // Determine if the current item can render
    const childPermissions = item.children?.flatMap((child) => child.permissions ?? []) ?? [];
    const userCanAccessPageOrSubPage = !item.permissions || hasPermissionTo(item.permissions) || hasPermissionTo(childPermissions);
    const userCanAccessSystem = item.systemIds?.some((systemId) => systemId === selectedSystem?.id) ?? false;
    const storeCanAccessPage = !item.storePermission || hasStorePermission(item.storePermission ?? [], configurations);
    const hasStatusAccess = canAccessPageStatus(item.status, {
      hostname: typeof window === 'undefined' ? undefined : window.location.hostname,
      hasAdminPermission: hasPermissionTo(['Admin']),
    });
    // Demo Mode bypasses permission/system/store checks entirely for demo-flagged items —
    // hasStatusAccess already requires Demo Mode to be enabled for 'demo' status items.
    const bypassForDemo = item.status === 'demo' && hasStatusAccess;
    // Some items should be hidden entirely while Demo Mode is enabled (e.g. superseded by a
    // demo equivalent) — this takes priority over every other check.
    const hiddenByDemo = shouldHideInDemo(item.hideInDemo);

    // Children must be evaluated before the parent so a parent group with no visible children
    // (e.g. every child is gated out for the currently selected demo persona) doesn't render as
    // an empty, clickable menu entry.
    item.children?.forEach(i => checkPermissions(i, configurations));
    const hasVisibleChild = item.children?.some(c => c.canRender) ?? false;
    const hasChildren = (item.children?.length ?? 0) > 0;

    const canRender = !hiddenByDemo && (bypassForDemo || (userCanAccessPageOrSubPage && storeCanAccessPage && userCanAccessSystem && hasStatusAccess && (!hasChildren || hasVisibleChild)));

    item.canRender = canRender;

    return item.canRender;
  };

  const isHighLighted = (item: DrawerNavItem, pathname: string, search: string) => {
    const urlEquals: boolean = item.children ? item.children.some(i => i?.href === pathname) : item?.href === pathname;

    const fullUrl = pathname + search;
    let urlstarts: boolean = item.children ? item.children.some(i => fullUrl.startsWith(i?.href ?? '-')) : fullUrl.startsWith(item.href ?? '-');

    if (search === '' || item.href === '/') {
      urlstarts = false;
    }

    return urlEquals || urlstarts;
  };

  return { storeConfig, open, setOpen, isMobile, isHighLighted, selectedNavItem, setSelectedNavItem, appNavItemsToUse, handleNavItemClick, systemNavItemsToUse, slidingSubMenuWidth };
};
